export const LOGIN_REGEX = /^[A-Za-z0-9_\u2012\u2013\u2014\u2015\-]*$/;

export const NAME_REGEX =
  /^[\p{L}\p{M}'\u2012\u2013\u2014\u2015\-\s\.\d’‘`]*$/u;
